module.exports = __webpack_public_path__ + "static/media/user-visor.9f9bb92d.svg";